var map = {
	"./1pa.svg": 1089,
	"./devb.webp": 4769,
	"./ek-cup-tcha.png": 8363,
	"./high-on-ai.png": 9260,
	"./infotainer.png": 6320,
	"./meme-funcs.png": 8255,
	"./paper-games.png": 9813,
	"./past-horror.png": 940,
	"./pypi.svg": 9283,
	"./repo.svg": 2243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;